import { defaultToolTip } from '@components/charts/config';
import D_Number from '@utils/number';

// -$50 => ($50)
const minusToParenthesis = (str) => {
  if (!str) {
    return null;
  }
  if (str[0] === '-') {
    return `(${str.replace(/^./, '')})`;
  }
  return str;
};

export const wrap = (s) =>
  s.replace(/(?![^\n]{1,25}$)([^\n]{1,25})\s/g, '$1<br> ');
// 单词换行用-拼接
// n: 多少个字符换行
const newWrap = (str, n = 25) => {
  const len = str.length;
  let strTemp = ''; // 已经拼接好的字符
  const wrapStr = '<br />'; // 换行拼接字符
  if (len > n) {
    strTemp = str.substring(0, n);
    str = str.substring(n, len);
    // 暂时不要拼接-的逻辑了
    // if (str[0] && str[0] === ' ') {
    //     wrapStr = '<br />'
    // } else {
    //     wrapStr = '-<br />'
    // }
    return strTemp + wrapStr + newWrap(str);
  }
  return str;
};

const formatWaterfallData = (dataSrc) =>
  (Array.isArray(dataSrc) ? dataSrc : []).reduce((acc, e, i, arr) => {
    const formatY = minusToParenthesis(D_Number.addSeparator(Number(e.value)));
    const commonData = {
      name: e.l1,
      comment: e.comment,
      y: Number(e.value),
      formatY,
    };

    if (e.l2 === 'Sum') {
      return [
        ...acc,
        {
          ...commonData,
          isSum: arr.length - 1 === i,
          color: '#E45C2B',
          dollarValue: minusToParenthesis(D_Number.fixtoDollar(e.sumResult)),
          isIntermediateSum: arr.length - 1 !== i,
        },
      ];
    }

    return [
      ...acc,
      {
        ...commonData,
        dollarValue: minusToParenthesis(D_Number.fixtoDollar(e.value)),
        color: i === 0 ? '#E45C2B' : null,
      },
    ];
  }, []);

export const buildWaterfallChartOption = (inputData, isLightMode) => {
  const data = formatWaterfallData(inputData);
  const showCurrency =
    (inputData && inputData[0] && inputData[0].showCurrency) || false;
  // const showCurrency = inputData.some((r) => r.showCurrency || false);

  // 从新设置color的值，他这块非常奇怪，明明没设置color但是dark模式的时候一直有个333颜色【defaultToolTip也没得】
  if (isLightMode) {
    defaultToolTip.style.color = '#333333';
  } else {
    defaultToolTip.style.color = '#DBDBDB';
  }

  const result = {
    chart: {
      type: 'waterfall',
      events: {
        render() {},
      },
    },
    title: {
      text: undefined,
    },
    xAxis: {
      type: 'category',
    },
    yAxis: {
      title: {
        text: undefined,
      },
      gridLineColor: 'var(--waterfallGridLineColor)',
      labels: {
        formatter() {
          return null;
        },
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      ...defaultToolTip,
      followPointer: true,
      // positioner: function () {
      //   return { x: 0, y: 0 };
      // },
      enabled: true,
      // pointFormat: '<b>{point.dollarValue}</b><br><b>{point.comment}</b>',
      formatter() {
        const mainPart = `<div>${wrap(this.point.name)}</div>
                <br></br>
                <div>${
                  showCurrency ? this.point.dollarValue : this.point.formatY
                }</div>`;
        if (this.point.comment) {
          const commentPart = `<br></br>
                <div>${wrap(this.point.comment)}</div>`;
          return `<div>${mainPart}${commentPart}</div>`;
        }
        return `<div>${mainPart}</div>`;
      },
    },

    series: [
      {
        upColor: '#0081E9',
        color: '#FFB600',
        data,
        dashStyle: 'dash',
        // line color here won't take effect because color is override by introduced highcharts css
        lineColor: '#999999',
        borderWidth: 0,
        borderRadius: 0,
        dataLabels: {
          enabled: true,
          y: -25,
          verticalAlign: 'top',
          style: {
            fontWeight: 'bold',
            color: isLightMode ? '#000000' : 'white',
            border: 'none',
            textOutline: 'none',
          },
          pointFormat: showCurrency
            ? '<b>{point.dollarValue}</b>'
            : '<b>{point.formatY}</b>',
        },
        pointPadding: 0,
      },
    ],

    credits: {
      enabled: false,
    },
  };

  return result;
};
